<template>
    <div class="layout-detail-info-line layout-detail-info-line-yellow">
        <label class="layout-detail-info-label">人元司令：</label>
        <div class="layout-detail-info-content" v-if="detailInfoData.renyuansiling">
            <p class="layout-dic-text"><span v-bind:class="'wd-'+detailInfoData.renyuansiling.xing.propXingEn">{{detailInfoData.renyuansiling.text + detailInfoData.renyuansiling.xing.propXing}}</span></p>
        </div>
        <label class="layout-detail-info-label" v-if="detailInfoData.minggong">命宫：</label>
        <div class="layout-detail-info-content" v-if="detailInfoData.minggong">
            <p v-if="personInfo.unknown == 1" class="layout-dic-text">不详</p>
            <p v-else class="layout-dic-text">
                <span v-bind:class="'wd-'+detailInfoData.minggong.gan.xing">{{detailInfoData.minggong.gan.text}}</span>
                <span v-bind:class="'wd-'+detailInfoData.minggong.zhi.xing">{{detailInfoData.minggong.zhi.text}}</span>
            </p>
        </div>
        <!-- <label class="layout-detail-info-label" v-if="detailInfoData.shengong">身宫：</label>
        <div class="layout-detail-info-content" v-if="detailInfoData.shengong">
            <p class="layout-dic-text">
                <span v-bind:class="'wd-'+detailInfoData.shengong.gan.xing">{{detailInfoData.shengong.gan.text}}</span>
                <span v-bind:class="'wd-'+detailInfoData.shengong.zhi.xing">{{detailInfoData.shengong.zhi.text}}</span>
            </p>
        </div> -->
        <label class="layout-detail-info-label" v-if="detailInfoData.taiyuan">胎元：</label>
        <div class="layout-detail-info-content" v-if="detailInfoData.taiyuan">
            <p class="layout-dic-text">
                <span v-bind:class="'wd-'+detailInfoData.taiyuan.gan.xing">{{detailInfoData.taiyuan.gan.text}}</span>
                <span v-bind:class="'wd-'+detailInfoData.taiyuan.zhi.xing">{{detailInfoData.taiyuan.zhi.text}}</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DetailOtherInfo',
    computed: {
        personInfo() {
            return this.$store.state.detail.personInfo;
        },
        detailInfoData() {
            return this.$store.state.detail.detailInfoData;
        }
    }
}
</script>